import Swiper from 'swiper';

const hubspotServices = {
  init() {
    if ($('.process-card-services').length > 0) {
      this.initSlider();
    }
  },

  initSlider() {
    new Swiper($('.process-card-services')[0], {
      loop: true,
      speed: 700,
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      slidesPerView: 4,
      spaceBetween: 0,
      breakpoints: {
       480: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        375: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
      },
    });
  },
};

export default hubspotServices;



// WEBPACK FOOTER //
// ./scripts/modules/components/_services-slider.js